export const TABLIST = {
  GROUP: 'group',
  RANK: 'rank',
};
